<template>
    <v-container class="container">
        <v-expansion-panels
            v-model="panel"
            class="expansion-panel"
            :disabled="!this.isAdmin"
        >
            <v-expansion-panel>
                <v-expansion-panel-header class="card-title mt-1">
                    <div>
                        Καμπίνες
                        <v-icon v-if="this.isAdmin" :color="theming.cardsAndTablesText || 'black'" class="px-4" @click.stop="togglePanel()" large>
                            mdi-tune
                        </v-icon>
                    </div>
                </v-expansion-panel-header>
                <v-divider/>
                <v-expansion-panel-content>
                    <div class="filters">
                        <div class="client-filter-wrapper">
                            <v-select
                                v-model="selectedClientId"
                                :items="clients"
                                item-value="id"
                                item-text="name"
                                label="Πάροχος"
                                clearable
                                outlined
                                class="filter-field clients"
                            ></v-select>
                        </div>
                        <div class="input-filters">
                            <v-text-field
                                v-model="searchInput"
                                label="Αναζήτηση με ΤΕΚ, Κέντρο, Καμπίνα"
                                type="text"
                                class="filter-field client-name"
                                :disabled="!this.selectedClientId"
                                clearable
                            >
                            </v-text-field>
                        </div>
                        <div class="input-filters">
                            <v-text-field
                                v-model="searchInputLocation"
                                label="Αναζήτηση με A/K"
                                type="text"
                                class="filter-field client-name"
                                :disabled="!this.selectedClientId"
                                clearable
                            >
                            </v-text-field>
                        </div>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <array-view class="table" :items="cabins" :headers="headers" :totalPages="totalPages" :page="page" :size="size" @paginationChange="paginationChange" @item-clicked="userSelect"/>
    </v-container>
</template>
<script>
    import cabinService from '@/services/cabin'
    import ArrayView from '@/components/ArrayView.vue'
    import jwtUtil from '@/utils/jwtUtil'
    import client from '@/services/client'

    export default {
        components: { ArrayView },
        watch: {
            searchInput: {
                handler(newVal, oldVal) {
                    if (!newVal || newVal.length === 0 || newVal.length > 1) {
                        this.getCabins()
                    }
                }
            },
            searchInputLocation: {
                handler(newVal, oldVal) {
                    if (!newVal || newVal.length === 0 || newVal.length > 1) {
                        this.getCabins()
                    }
                }
            },
            selectedClientId: {
                handler(newVal, oldVal) {
                    this.getCabins()
                }
            }
        },
        computed: {
            userRoles() {
                return jwtUtil.getRoles(this.$store.getters.getToken)
            },
            theming() {
                return this.$store.getters.getTheming || {}
            },
            isAdmin() {
                return this.containsAny(['ROLE_ADMIN'], this.userRoles)
            }
        },
        data() {
            return {
                cabins: [],
                headers: [
                    {
                        text: 'Κωδικός Συστήματος',
                        align: 'start',
                        sortable: false,
                        value: 'systemCode'
                    },
                    { text: 'Α/Κ', value: 'nameAK' },
                    { text: 'Κωδικός ΤΕΚ', value: 'tekCode' },
                    { text: 'Κωδικός Κέντρου', value: 'centreCode' },
                    { text: 'Καμπίνα', value: 'cabin' },
                    { text: 'Σημείο Χάρτη', value: 'coordinates', align: 'center' }
                ],
                sizes: [5, 10, 30, 60, 100],
                page: 1,
                size: 10,
                totalPages: 0,
                clients: [],
                sort: null,
                panel: null,
                searchInput: null,
                searchInputLocation: null,
                selectedClientId: null,
                editDialog: false,
                selectedUser: null
            }
        },
        created() {
            this.getAllClients()
        },
        methods: {
            userSelect(e) {
                if (this.isAdmin) {
                    this.selectedUser = e
                    this.editDialog = true
                }
            },
            getCabins() {
                let filter = {}
                if (this.selectedClientId) {
                    filter.clientId = this.selectedClientId
                }
                if (this.searchInput) {
                    filter.searchInput = this.searchInput
                }
                if (this.searchInputLocation) {
                    filter.searchInputLocation = this.searchInputLocation
                }
                cabinService.getCabins(this.page, this.size, filter, this.sort).then(resp => {
                    this.cabins = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            },
            togglePanel() {
                if (!this.isAdmin) {
                    return
                }
                const curr = this.panel
                this.panel = curr === undefined ? 0 : undefined
            },
            paginationChange(page, size) {
                this.page = page
                this.size = size
                this.getCabins()
            },
            getAllClients() {
                client.getAllClients().then(resp => {
                    this.clients = resp.data
                    if (this.clients.length === 1) {
                        this.selectedClientId = this.clients[0].id
                    }
                })
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            }
        }
    }
</script>
<style scoped>
.client-filter-wrapper {
    width: 100%;
}
.container {
    padding-top: 3%;
}
.search-button-wrapper {
    display: flex;
    justify-content: center;
}
.name {
    font-weight: bold;
    font-size: calc(1vw + 2vh);
}
.card-title {
    font-weight: 500;
    font-size: 1.4rem;
}
.table {
    width: 85%;
}

.expansion-panel {
    max-width: 90%;
    margin: 0 auto;
}

@media only screen and (max-width: 540px) {
.expansion-panel {
    max-width: 100%;
}

}
.v-expansion-panel {
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}
.create-new {
    display: flex;
    justify-content: end;
}

.filter-field {
    padding: 0.8rem;
}

.clients {
    margin: 0 auto;
    min-width: 250px;
    max-width: 400px;
}
.input-filters {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.filters {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.card-actions {
    display: flex;
    justify-content: center;
}
</style>
